
import { axios } from '@/utils/request'

const api = {
  options: '/adminapi/dabiao/options',
  getApplyList: '/adminapi/dabiao/shengManageList',
  getMemberList: '/adminapi/dabiao/memberList',
  manageEdit: '/adminapi/dabiao/shengManageEdit',
  refreshCert: '/adminapi/dabiao/refreshCert',
  checkShengMemberOK: '/adminapi/dabiao/checkShengMemberOK', 
  shengApply: '/adminapi/dabiao/shengApply',
  getShengShenheUrls: '/adminapi/dabiao/getShengShenheUrls',
  shengapplydetail: '/adminapi/dabiao/shengapplydetail',
  shengApplyDelete: '/adminapi/dabiao/shengApplyDelete',
  dabiaoList: '/adminapi/dabiao/dabiaoList',
  getMemberDetail: '/adminapi/dabiao/dabiaodetail',
  shengDetail: '/adminapi/dabiao/shengDetail',
  shengDelete: '/adminapi/dabiao/shengDelete',
  editMember: '/adminapi/dabiao/dabiaoedit',
  shengEdit: '/adminapi/dabiao/shengCpEdit',
  dabiaoDelete: '/adminapi/dabiao/dabiaodelete',

 
}

export default api

export function getOptions(parameter) {
  return axios({
    url: api.options,
    method: 'get',
    params: parameter
  })
}
export function getApplyList(parameter) {
  return axios({
    url: api.getApplyList,
    method: 'get',
    params: parameter
  })
}
export function getGuoApplyList(parameter) {
  return axios({
    url: api.getGuoApplyList,
    method: 'get',
    params: parameter
  })
}

export function getCaipanList(parameter) {
  return axios({
    url: api.dabiaoList,
    method: 'get',
    params: parameter
  })
}
export function getMemberList(parameter) {
  return axios({
    url: api.getMemberList,
    method: 'get',
    params: parameter
  })
}
export function refreshCert(parameter) {
  return axios({
    url: api.refreshCert,
    method: 'get',
    params: parameter
  })
}

export function getGuoMemberList(parameter) {
  return axios({
    url: api.getGuoMemberList,
    method: 'get',
    params: parameter
  })
}

export function getCaipanDetail(parameter) {
  return axios({
    url: api.dabiaoDetail,
    method: 'get',
    params: parameter
  })
}
export function getShengCaipanDetail(parameter) {
  return axios({
    url: api.shengCpDetail,
    method: 'get',
    params: parameter
  })
}
export function checkShengMemberOK(parameter) {
  return axios({
    url: api.checkShengMemberOK,
    method: 'get',
    params: parameter
  })
}

export function checkGuoMemberOK(parameter) {
  return axios({
    url: api.checkGuoMemberOK,
    method: 'get',
    params: parameter
  })
}

export function editMember(parameter) {
  return axios({
    url: api.editMember,
    method: 'post',
    data: parameter
  })
}

export function editShengCaipan(parameter) {
  return axios({
    url: api.shengCpEdit,
    method: 'post',
    data: parameter
  })
}
export function editShengCpManage(parameter) {
  return axios({
    url: api.manageEdit,
    method: 'post',
    data: parameter
  })
}
export function shengcpApply(parameter) {
  return axios({
    url: api.shengcpApply,
    method: 'post',
    data: parameter
  })
}
export function getShengShenheUrls(parameter) {
  return axios({
    url: api.getShengShenheUrls,
    method: 'post',
    data: parameter
  })
}
export function getShengApplyDetail(parameter) {
  return axios({
    url: api.shengapplydetail,
    method: 'post',
    data: parameter
  })
}
export function shengApplyDelete(parameter) {
  return axios({
    url: api.shengApplyDelete,
    method: 'get',
    params: parameter
  })
}

export function deleteMember(parameter) {
  return axios({
    url: api.dabiaoDelete,
    method: 'post',
    data: parameter
  })
}

export function deleteSheng(parameter) {
  return axios({
    url: api.shengDelete,
    method: 'post',
    data: parameter
  })
}



export function guocpApply(parameter) {
  return axios({
    url: api.guocpApply,
    method: 'post',
    data: parameter
  })
}
export function getGuoShenheUrls(parameter) {
  return axios({
    url: api.getGuoShenheUrls,
    method: 'post',
    data: parameter
  })
}
export function getMemberDetail(parameter) {
  return axios({
    url: api.getMemberDetail,
    method: 'post',
    data: parameter
  })
}
export function guoApplyDelete(parameter) {
  return axios({
    url: api.guoApplyDelete,
    method: 'get',
    params: parameter
  })
}
